//  和用户相关的状态管理

import { createSlice } from '@reduxjs/toolkit'
import { setToken as _setToken, getToken, setUserInfo as _setUserInfo, getUserInfo, setLoginTime as _setLoginTime, getLoginTime } from '@/utils/token'
import { loginAPI, loginPhoneAPI } from '@/apis/user'
import { message } from 'antd';
import Dayjs from 'dayjs'

const userStore = createSlice({
  name: 'user',
  //  数据状态
  initialState: {
    token: getToken() || '',
    userInfo: getUserInfo() || {},
    loginTime: getLoginTime() || ''
  },
  //  同步修改方法
  reducers: {
    setToken(state, action) {
      state.token = action.payload
      _setToken(action.payload)
    },
    setUserInfo(state, action) {
      state.userInfo = action.payload
      _setUserInfo(action.payload)
    },
    setLoginTime(state, action) {
      state.loginTime = action.payload
      _setLoginTime(action.payload)
    }
  }
})

//  解构出actionCreater
const { setToken, setUserInfo, setLoginTime } = userStore.actions

//  获取reducer函数
const userReducer = userStore.reducer

//  异步请求方法 完成微信登录获取token
const fetchLogin = loginForm => {
  return async dispatch => {
    //  1. 发送异步请求
    const res = await loginAPI(loginForm)
    if (res.success === true) {
      //  2. 提交同步action进行token的存入
      dispatch(setToken(res.result.token))
      dispatch(setUserInfo(res.result))
      dispatch(setLoginTime(Dayjs().format('YYYY-MM-DD HH:mm:ss')))
    } else {
      message.error(res.message)
    }
  }
}
//  异步请求方法 完成登录获取token
const fetchLoginPhone = loginForm => {
  return async dispatch => {
    //  1. 发送异步请求
    const res = await loginPhoneAPI(loginForm)
    if (res.success === true) {
      //  2. 提交同步action进行token的存入
      dispatch(setToken(res.result.token))
      dispatch(setUserInfo(res.result))
      dispatch(setLoginTime(Dayjs().format('YYYY-MM-DD HH:mm:ss')))
      message.success('登录成功')
    } else {
      message.error(res.message)
    }
    return res.success;
  }
}

export { fetchLogin, fetchLoginPhone, setToken, setUserInfo, setLoginTime }

export default userReducer
